import { ReplaySubject } from "rxjs";
import { Item } from "../utils/boxTypes";
// apiConfig.ts

console.log("Loaded base URL from env:", process.env.REACT_APP_API_BASE_URL);

export const baseURL = process.env.REACT_APP_API_BASE_URL!;
export const vpcPriceUrl = process.env.REACT_APP_VPC_PRICE_URL!;
export const SSO_BASE_URL = process.env.REACT_APP_API_SSO_BASE_URL!;
export const IMAGE_BASE_PATH = process.env.REACT_APP_IMAGE_BASE_PATH!;
export const ENVIRONMENT = process.env.REACT_APP_ENV!;
export const SLIDES_DELAY_KEY = "slides_delay"
export const IS_PRODUCTION = ENVIRONMENT === "production";
export default baseURL

export const getWinningItemsSubject = new ReplaySubject<Item[]>(1);
type WinningItemState = { items: Item[] | null };

export const getWinningItemsSubjectForAnimation = new ReplaySubject<WinningItemState>(1);

export const winningAnimationInProgressSubject = new ReplaySubject<boolean>(1);
